<div class="m-form__group">
    <div class="main-title">
        <h2 class="heading" [attr.data-test-id]="testId + '.title'">Reference:</h2>
    </div>
    <form #f="ngForm" [attr.data-test-id]="testId + '.form'">
        <div class="row">
            <div class="{{cssWidthClass}}">
                <mat-form-field class="mat-form-field-fluid">
                    <mat-label [attr.data-test-id]="testId + '.first-name-label'">First Name</mat-label>
                    <input matInput type="text" name="firstName" alphabetWithSpace
                           autocomplete="off" [(ngModel)]="referenceApplicant.firstName"
                           #firstName="ngModel"
                           required
                           [attr.data-test-id]="testId + '.first-name-input'">
                    <mat-error [attr.data-test-id]="testId + '.first-name.required-error'">Please enter the first name.</mat-error>
                </mat-form-field>
            </div>
            <div class="{{cssWidthClass}}">
                <mat-form-field class="mat-form-field-fluid">
                    <mat-label [attr.data-test-id]="testId + '.last-name-label'">Last Name</mat-label>
                    <input matInput type="text" name="lastName" alphabetWithSpace
                           autocomplete="off" [(ngModel)]="referenceApplicant.lastName"
                           #lastName="ngModel"
                           required
                           [attr.data-test-id]="testId + '.last-name-input'">
                    <mat-error [attr.data-test-id]="testId + '.last-name.required-error'">Please enter the last name.</mat-error>
                </mat-form-field>
            </div>
            <div class="{{cssWidthClass}}">
                <mat-form-field class="mat-form-field-fluid">
                    <mat-label [attr.data-test-id]="testId + '.phone-label'">Phone Number</mat-label>
                    <input matInput type="tel" name="primaryPhone" phone-mask maxlength="14"
                           autocomplete="off"
                           [(ngModel)]="referenceApplicant.primaryPhone" #primaryPhone="ngModel" phone="true"
                           required
                           [attr.data-test-id]="testId + '.phone-input'">
                    <mat-error *ngIf="primaryPhone.hasError('required')" [attr.data-test-id]="testId + '.phone.required-error'">Please enter contact number.
                    </mat-error>
                    <mat-error *ngIf="primaryPhone.hasError('min-max')" [attr.data-test-id]="testId + '.phone.invalid-error'">Please enter a valid contact number.
                    </mat-error>
                </mat-form-field>
            </div>
            <div class="{{cssWidthClass}}">
                <mat-form-field class="mat-form-field-fluid">
                    <mat-label [attr.data-test-id]="testId + '.email-label'">E-mail</mat-label>
                    <input matInput name="email"
                           autocomplete="off" [(ngModel)]="referenceApplicant.email"
                           #email="ngModel" min-max
                           required
                           [attr.data-test-id]="testId + '.email-input'">
                    <mat-error *ngIf="email.hasError('required')" [attr.data-test-id]="testId + '.email.required-error'">Please enter an email address.
                    </mat-error>
                    <mat-error *ngIf="email.hasError('email')" [attr.data-test-id]="testId + '.email.invalid-error'">Please enter a valid email address.
                    </mat-error>
                </mat-form-field>
            </div>
            <div class="col-sm-12">
                <creditsnap-address #address id="referenceApplicantAddress" [(ngModel)]="referenceApplicant.address"
                                    name="referenceApplicantAddress"
                                    [attr.data-test-id]="testId + '.address'"></creditsnap-address>
            </div>
        </div>
    </form>
</div>
